import React, { createContext, useContext, useState } from 'react';

const LoaderContext = createContext(null);

export const LoaderProvider = ({ children }) => {
  const [isLoading, setLoading] = useState(false);
  return <LoaderContext.Provider value={{ isLoading, setLoading }}>{children}</LoaderContext.Provider>;
};

export const useLoader = () => {
  const ctx = useContext(LoaderContext);
  if (!ctx) throw new Error('useLoader must be used within LoaderProvider');
  return ctx;
};
